import { Component, Prop, Vue } from 'vue-property-decorator';
import AgendaHierarchyItemComponent from './../agenda-hierarchy-item-component/agenda-hierarchy-item-component.vue';
import HierarchyComponent from '@/shared/components/hierarchy-component/hierarchy-component.vue';
import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';
import { IAgendaHierarchyPropertyBag } from '../../models/agenda-hierarchy-property-bag';

interface IViewModel {

    isInitialized: boolean;
}

@Component({
    components: {
        HierarchyComponent,
        AgendaHierarchyItemComponent,
    }
})
export default class AgendaModalComponent extends Vue {

    @Prop() agenda!: IHierarchyNode<IAgendaItem>[];
    @Prop() agendaHierarchyPropertyBag!: IAgendaHierarchyPropertyBag;
    @Prop() public translations!: { [key: string]: string; };

    public modalDomElementId = `easyvote-agenda-modal-${Math.floor((Math.random() * 99999999) + 1)}`;

    public viewModel: IViewModel = {

        isInitialized: false
    };

    public async open($event?: MouseEvent): Promise<void> {

        if ($event) {
            $event.preventDefault();
        }

        $(`#${this.modalDomElementId}`).modal('show');

        this.viewModel.isInitialized = true;
    }

    public async close($event?: MouseEvent): Promise<void> {

        if ($event) {
            $event.preventDefault();
        }

        $(`#${this.modalDomElementId}`).modal('hide');
    }
}